module.exports = __webpack_public_path__ + "static/09-12ecf6b31e47cefba0032f1aea709783.png";